import { Box, Button, InputAdornment, TextField, Typography } from "@mui/material";
import { COLOR } from "../../../utils/colors";
import { VIEW } from "../../../utils/breakpoint";
import { Link, useNavigate } from "react-router-dom";
import { AddOutlined } from "@mui/icons-material";
import { GridSearchIcon } from "@mui/x-data-grid";
import { useState } from "react";
import LayoutMapTable from "../quick-setup/_components/layout-map-table";

export default function ConfigLayoutMapsPage() {
  const [searchTerm, setSearchTerm] = useState("");
  const navigate = useNavigate()

  const onEditMap = (mapId: string) => {
    navigate('/config/layout-maps/' + mapId)
  }

  return (
    <Box sx={(theme) => ({
      paddingY: '34px',
      color: COLOR.neutral[900],
      [theme.breakpoints.up(VIEW .PHONE)]: {
        paddingX: '24px',
      },
      [theme.breakpoints.up(VIEW.TABLET)]: {
        paddingX: '44px',
      }
    })}>
      <Box sx={{ display: 'flex', flexDirection: 'column' }}>
        <Typography
          sx={{
            fontSize: '24px',
            fontWeight: 600,
            color: COLOR.neutral[900]
          }}
        >
          Layout Maps
        </Typography>
        <Box sx={(theme) => ({
          display: 'flex',
          gap: '12px',
          marginTop: '16px',
          [theme.breakpoints.down(VIEW.TABLET)]: {
            flexDirection: 'column'
          }
        })}>
          <TextField
            id="search-store-name"
            variant="outlined"
            size="small"
            placeholder='Search Layout Map'
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            sx={{
              flex: 'auto',
              backgroundColor: 'white',
              height: "40px",
            }}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <GridSearchIcon />
                </InputAdornment>
              ),
            }}
          />
          <Link to="/config/layout-maps/create">
            <Button variant="outlined" startIcon={<AddOutlined />}>
              New Layout Map
            </Button>
          </Link>
        </Box>
      </Box>
      <LayoutMapTable search={searchTerm} onEdit={(mapId) => onEditMap(mapId)} />
    </Box>
  )
}